import {PATHS} from '@freckle/educator-entities/ts/common/helpers/paths'
import {Flex} from '@freckle/educator-materials/ts/components/flex'
import {Link} from '@freckle/educator-materials/ts/components/link'
import {H1, Text} from '@freckle/educator-materials/ts/components/typography'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {SafeTrans} from '@freckle/educator-materials/ts/helpers/translate/component'

export function ErrorPage() {
  const {t} = useSafeTranslation()
  const goBackLink = <Link href={PATHS.schoolDashUrl} reactRouter={false} />
  return (
    <Flex flexDirection="column" justifyContent="center" alignItems="center">
      <H1>{t('ERROR_PAGE_TITLE')}</H1>
      <Text>
        <SafeTrans i18nKey="ERROR_PAGE_GO_BACK_TEXT" components={{goBackLink}} />
      </Text>
      <Text>{t('ERROR_PAGE_SUPPORT_TEXT')}</Text>
    </Flex>
  )
}
